export default __webpack_public_path__ + "static/grain-027de0e39e65d61a1a5bc225d3fb4b94.jpg";